exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card {\n  margin-bottom: 5px; }\n\n.card-block {\n  padding: 5px;\n  font-size: 14px; }\n\n.btn, .fc button {\n  background: white; }\n\n.fa-remove:before, .fa-close:before, .fa-times:before {\n  color: grey; }\n\ndiv.category.col-11 {\n  padding-left: 0px; }\n\n.color {\n  color: #ff8080; }\n\nlabel {\n  display: inline-block;\n  margin-top: 10px;\n  margin-left: 17px; }\n\n@media (max-width: 600px) {\n  .color[_ngcontent-c3] {\n    margin-top: -22px;\n    text-align: right;\n    background: transparent;\n    margin-left: 220px; }\n  div.category.col-11[_ngcontent-c2] {\n    padding-left: 0px;\n    height: 17px !important; }\n  div.category.col-11[_ngcontent-c3] {\n    padding-left: 0px;\n    margin-bottom: -14px;\n    margin-left: 10px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/users/components/role-list/role-list.component.scss
// module id = 510
// module chunks = 5